module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07402_banner_800x600.2d0281b3.png";